import Renderer from "../Renderer";
import NotificationBar from "./../utils/NotificationBar";

/**
 *
 *
 * @author Jaap
 * @date 24-09-2019
 */
export default class SharePanel {
    constructor(panelElement) {
        this.sharePanel = panelElement;
        this.sharePanel.querySelectorAll(".sidepanel-shareitem").forEach((entry) => {
            entry.addEventListener("click", this.shareMessage.bind(this));
        });

        this.sharePanel.querySelectorAll("input[type=radio]").forEach((entry) => {
            entry.addEventListener("change", this.setChecked.bind(this));
        });

        this._shareTemplate = document.getElementById("HB-sidemenu-share").innerHTML;
    }

    activated(issue, spreads) {
        this.renderSpreads(issue, spreads);
    }

    shareMessage(event) {
        event.preventDefault();
        if (window.previewMode) {
            NotificationBar.showNotification(
                window.interface_settings?.settings?.text?.warning_preview_share_disabled,
                "warning",
            );
        } else {
            let path = location.pathname;
            if (this.sharePanel.querySelector('input[type="radio"]:checked').value === "issue") {
                path = `/${path.split("/")[1]}`;
            }

            const fullUrl = `${location.protocol}//${location.hostname + path}`;
            const shareUrl = event.currentTarget.href;

            window.open(`${shareUrl}${encodeURIComponent(fullUrl)}`);
        }
    }

    setChecked(event) {
        this.sharePanel.querySelectorAll("[aria-checked]").forEach((entry) => {
            entry.setAttribute(
                "aria-checked",
                entry === event.currentTarget.closest("[aria-checked]") ? "true" : "false",
            );
        });
    }

    async fetchMetaData(issue_id, spread_id) {
        return await $.ajax(`/s/api/meta/${issue_id}/${spread_id}`);
    }

    renderSpreads(issue, spreads) {
        const spread = spreads.find((spread) => spread.spread_id === window.frontend.getCurrentSpreadId());
        if (spread) {
            const renderAndInject = () => {
                const html = Renderer.renderSource(this._shareTemplate, { issue: issue, spread: spread });
                Renderer.nativeInject("sidemenu-share-content", html);
            };

            //render meta data
            renderAndInject();
            if (!spread.meta) {
                //if we dont have all the meta data yet, fetch it and rerender.
                this.fetchMetaData(issue.issue_id, spread.spread_id)
                    .then((data) => {
                        spread.meta = data.message;
                        renderAndInject();
                    })
                    .catch((error) => {
                        console.error("MAGLR ERROR: [SharePanel.renderSpreads]", error);
                    });
            }
        }
    }
}
